// Tiny localStorage wrapper for v1 scenario + listing persistence.
// Swapped out for /api/* once D1 is wired up.

const SCENARIOS_KEY = 'percy.scenarios.v1';
const DEFAULTS_KEY = 'percy.defaults.v1';
const LISTINGS_KEY = 'percy.listings.v1';

export function listScenarios() {
  try { return JSON.parse(localStorage.getItem(SCENARIOS_KEY) ?? '[]'); }
  catch { return []; }
}

export function saveScenario(scenario) {
  const all = listScenarios();
  const now = new Date().toISOString();
  const id = scenario.id ?? `sc_${Date.now().toString(36)}`;
  const next = { ...scenario, id, updated_at: now, created_at: scenario.created_at ?? now };
  const i = all.findIndex((s) => s.id === id);
  if (i >= 0) all[i] = next; else all.push(next);
  localStorage.setItem(SCENARIOS_KEY, JSON.stringify(all));
  return next;
}

export function getScenario(id) {
  return listScenarios().find((s) => s.id === id) ?? null;
}

export function deleteScenario(id) {
  const all = listScenarios().filter((s) => s.id !== id);
  localStorage.setItem(SCENARIOS_KEY, JSON.stringify(all));
}

export function getDefaultOverrides() {
  try { return JSON.parse(localStorage.getItem(DEFAULTS_KEY) ?? '{}'); }
  catch { return {}; }
}

export function saveDefaultOverrides(overrides) {
  localStorage.setItem(DEFAULTS_KEY, JSON.stringify(overrides));
}

// ─── Ingest / Discovery ────────────────────────────────────────────────

const INGEST_KEY = 'percy.ingest.v1';
const CRITERIA_KEY = 'percy.criteria.v1';

export function getIngestResults() {
  try { return JSON.parse(localStorage.getItem(INGEST_KEY) ?? 'null'); }
  catch { return null; }
}

export function saveIngestResults(data) {
  localStorage.setItem(INGEST_KEY, JSON.stringify({
    ...data,
    fetched_at: new Date().toISOString(),
  }));
}

export function getCriteria() {
  try { return JSON.parse(localStorage.getItem(CRITERIA_KEY) ?? 'null'); }
  catch { return null; }
}

export function saveCriteria(criteria) {
  localStorage.setItem(CRITERIA_KEY, JSON.stringify(criteria));
}

export function resetCriteria() {
  localStorage.removeItem(CRITERIA_KEY);
}

// ─── Listings ──────────────────────────────────────────────────────────

export function listListings() {
  try { return JSON.parse(localStorage.getItem(LISTINGS_KEY) ?? '[]'); }
  catch { return []; }
}

export function saveListing(listing) {
  const all = listListings();
  const now = new Date().toISOString();
  const id = listing.id ?? `ls_${Date.now().toString(36)}`;
  const next = { ...listing, id, updated_at: now, created_at: listing.created_at ?? now };
  const i = all.findIndex((l) => l.id === id);
  if (i >= 0) all[i] = next; else all.push(next);
  localStorage.setItem(LISTINGS_KEY, JSON.stringify(all));
  return next;
}

export function getListing(id) {
  return listListings().find((l) => l.id === id) ?? null;
}

export function deleteListing(id) {
  const all = listListings().filter((l) => l.id !== id);
  localStorage.setItem(LISTINGS_KEY, JSON.stringify(all));
}
